export enum ROUTES {
    Home = '/',
    Login = '/auth/login',
    Logout = '/auth/logout',
    Register = '/auth/register',
    ForgotPassword = '/auth/forgot-password',
    VerifyEmail = '/auth/verify-email',
    ResetPassword = '/auth/reset-password',
    InvestorDeck = '/dashboard/investor-deck',
    InvestorDeckNew = '/dashboard/investor-deck-new',
    ExecutiveSummary = '/dashboard/executive-summary',
    ElevatorPitch = '/dashboard/elevator-pitch',
    FoundersLetter = '/dashboard/founders-letter',
    BusinessPlan = '/dashboard/business-plan',
    FinancialSummary = '/dashboard/financial-summary',
    OnePager = '/dashboard/one-pager',
    UseOfProceeds = '/dashboard/use-of-proceeds',
    HyperReport = '/hyper-report',
    Welcome = '/dashboard/welcome',
    FAQ = '/faq',
    AboutUs = '/about-us',
    ContactUs = '/contact-us',
    WhatYouGet = '/what-you-get',
    HowItWorks = '/how-it-works',
    Introduction = '/auth/introduction',
    CheckoutRedirect = '/auth/checkout-redirect',
    Contacts = '/dashboard/your-investors',
    ConnectedApps = '/dashboard/connected-apps',
}

export enum SETTINGS_ROUTES {
    PersonalDetails = '/settings/personal-details',
    CompanyDetails = '/settings/company-details',
    CompanyLogo = '/settings/company-logo',
    DataRooms = '/settings/data-rooms',
    SubscriptionPlan = '/settings/subscription-plan',
    Support = '/settings/support',
    UserApiKeys = '/settings/api-keys',
}

export enum MARKET_INTELLIGENCE_ROUTES {
    Email = '/dashboard/market-intelligence/email',
    Blog = '/dashboard/market-intelligence/blog',
    Linkedin = '/dashboard/market-intelligence/linkedin',
    TwitterThread = '/dashboard/market-intelligence/twitter-thread',
    IntelligenceReport = '/dashboard/market-intelligence/intelligence-report',
}

export enum DATA_ROOM_ROUTES {
    Home = '/data-room',
    OnePager = '/data-room/one-pager',
    InvestorDeck = '/data-room/investor-deck',
    ExecutiveSummary = '/data-room/executive-summary',
    BusinessPlan = '/data-room/business-plan',
    FinancialSummary = '/data-room/financial-summary',
    UseOfProceeds = '/data-room/use-of-proceeds',
    InvestmentOpportunity = '/data-room/investment-opportunity',
    RequestAccess = '/data-room/request-access',
}

export enum ENDPOINTS {
    CheckAccount = '/api/auth/check-account',
    Onboarding = '/api/onboarding',
    CompleteOnboarding = '/api/onboarding/complete',
    Conversations = '/api/conversations',
    Messages = '/api/conversations/messages',
    ChatAction = '/api/conversations/chat_action',
    CheckExtractions = '/api/conversations/check_extractions',
    File = '/api/onboarding/file',
    Preview = '/api/conversations/preview',
    Previews = '/api/conversations/previews',
    Prepare = '/api/conversations/prepare',
    GeneratePreview = '/api/conversations/preview/generate',
    GeneratePreviewPdf = '/api/conversations/preview/generate-pdf',
    StripePortal = '/api/stripe/portal',
    StripeCheckout = '/api/stripe/checkout',
    Profile = '/api/auth/me',
    Assets = '/api/assets',
    User = '/api/users',
    DataRoom = '/api/dataroom',
    Company = '/api/company',
    MarketContent = '/api/dataroom/market-content',
    MarketContentLatest = '/api/dataroom/market-content/latest',
    DataroomVisits = '/api/dataroom/visits',
}

export enum WORKERS {
    ActionItem = 'action-item',
    ConvertPDF = 'convert-pdf',
    FileExtraction = 'file-extraction',
    GeneratePDF = 'generate-pdf',
    Services = 'services',
}

export enum ACTION_ITEM_EP {
    SendMessage = '/send-message',
    ChatAction = '/chat-action',
    Prepare = '/prepare',
    GeneratePreview = '/generate-preview',
}

export enum SERVICES_EP {
    Notifications = '/notifications',
    Throttle = '/throttle',
    Tokenize = '/tokenize',
}
